module.exports = __webpack_public_path__ + "static/media/candidate.45fc97cf.svg";